export default __webpack_public_path__ + "static/transport2-img-e26fc94fb66e0517b997d2d8e434bc5a.jpg";